module.exports = __webpack_public_path__ + "img/OANDA_Onboarding_HeaderAnim_DE.dc979b4f.png";